const SET_DIRTY_FALSE = 'plan/setDirtyFalse';
export const setDirtyFalse = () => ({ type: SET_DIRTY_FALSE });

export const planDirtyReducer = (reducer) => (state, action) => {
    if (action.type === SET_DIRTY_FALSE) {
        return { ...state, dirty: false };
    }
    const nextState = reducer(state, action);
    if (nextState !== state) {
        return { ...nextState, dirty: true };
    }
    return nextState;
};